import React from 'react';
import './CanvasPicker.css';

import { MDBSelect } from 'mdb-react-ui-kit';
import { CanvasType } from '../../../types/image/CanvasType';

type Props = {
  className?: string;
  value: number;
  changeSelection: (x: CanvasType) => void;
};

const CanvasPicker: React.FC<Props> = ({
  className,
  value,
  changeSelection,
}: Props) => {
  const triggerChange = (e: any) => {
    changeSelection(e.value);
  };
  return (
    <div className={`CanvasPicker ${className}`}>
      <MDBSelect
        label='Canvas Type'
        data={[
          {
            text: 'Acrylic on canvas',
            value: CanvasType.ACRYLIC,
            defaultSelected: value === CanvasType.ACRYLIC,
          },
          {
            text: 'Acrylic + oil stick on canvas',
            value: CanvasType.ACRYLICANDOILSTICK,
            defaultSelected: value === CanvasType.ACRYLICANDOILSTICK,
          },
          {
            text: 'Chalk color on canvas',
            value: CanvasType.CHALKCOLOR,
            defaultSelected: value === CanvasType.CHALKCOLOR,
          },
          {
            text: 'Chalk color + graphite on canvas',
            value: CanvasType.CHALKCOLORANDGRAPHITE,
            defaultSelected: value === CanvasType.CHALKCOLORANDGRAPHITE,
          },
          {
            text: 'Chalk color + pastel on canvas',
            value: CanvasType.CHALKCOLORANDPASTELL,
            defaultSelected: value === CanvasType.CHALKCOLORANDPASTELL,
          },
        ]}
        onValueChange={triggerChange}
      />
    </div>
  );
};

export default CanvasPicker;
